import { render } from "./ClientCodeReviewDiagnostics.vue?vue&type=template&id=056ad61b&scoped=true"
import script from "./ClientCodeReviewDiagnostics.vue?vue&type=script&lang=js"
export * from "./ClientCodeReviewDiagnostics.vue?vue&type=script&lang=js"

import "./ClientCodeReviewDiagnostics.vue?vue&type=style&index=0&id=056ad61b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056ad61b"]])

export default __exports__